'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dGroups$002dPage$0024 from "./presto.-List-Groups-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002475 from "./presto.-Presto-Router$$anon$75.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$74() {
  this.blX = null;
  this.blP = null;
  this.blQ = false;
  this.blY = null;
  this.blZ = false;
  this.bm2 = null;
  this.blV = null;
  this.blW = false;
  this.blR = null;
  this.blS = false;
  this.blT = null;
  this.blU = false;
  this.bm0 = false;
  this.bm1 = false;
  this.blX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bm2 = "ListGroupsPage";
}
export { $c_Lpresto_PrestoRouter$$anon$74 as $c_Lpresto_PrestoRouter$$anon$74 };
$p = $c_Lpresto_PrestoRouter$$anon$74.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$74;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$74() {
}
export { $h_Lpresto_PrestoRouter$$anon$74 as $h_Lpresto_PrestoRouter$$anon$74 };
$h_Lpresto_PrestoRouter$$anon$74.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.blX;
});
$p.M = (function() {
  if ((!this.blQ)) {
    this.blP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.blQ = true;
  }
  return this.blP;
});
$p.O = (function() {
  if ((!this.blZ)) {
    this.blY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.blZ = true;
  }
  return this.blY;
});
$p.E = (function() {
  return this.bm2;
});
$p.t = (function() {
  if ((!this.blW)) {
    this.blV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blW = true;
  }
  return this.blV;
});
$p.N = (function() {
  if ((!this.blS)) {
    this.blR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blS = true;
  }
  return this.blR;
});
$p.Q = (function() {
  if ((!this.blU)) {
    this.blT = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002475.$c_Lpresto_PrestoRouter$$anon$75();
    this.blU = true;
  }
  return this.blT;
});
$p.v = (function() {
  if ((!this.bm1)) {
    this.bm0 = false;
    this.bm1 = true;
  }
  return this.bm0;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee514) => ((p) => \u03b4scrutinee514))($j_presto$002e$002dList$002dGroups$002dPage$0024.$m_Lpresto_ListGroupsPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$74 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$74, "presto.PrestoRouter$$anon$74", ({
  OR: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$74 as $d_Lpresto_PrestoRouter$$anon$74 };
//# sourceMappingURL=presto.-Presto-Router$$anon$74.js.map
